import { render, staticRenderFns } from "./TreasureBoxPopup.vue?vue&type=template&id=42f16d04&scoped=true"
import script from "./TreasureBoxPopup.vue?vue&type=script&lang=js"
export * from "./TreasureBoxPopup.vue?vue&type=script&lang=js"
import style0 from "./TreasureBoxPopup.vue?vue&type=style&index=0&id=42f16d04&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "42f16d04",
  null
  
)

export default component.exports